export const A_GET_COUNTRIES = "A_GET_COUNTRIES";
export const A_GET_CITIES = "A_GET_CITIES";
export const A_GET_CAPTCHA = "A_GET_CAPTCHA";
export const A_CHECK_MAIL = "A_CHECK_MAIL";
export const A_CHECK_REDIRECT_PERSONAL_ACCOUNT="A_CHECK_REDIRECT_PERSONAL_ACCOUNT";
export const A_CHECK_CAPTCHA = "A_CHECK_CAPTCHA";
export const A_GET_WARNING_AND_BAN_USER = "A_GET_WARNING_AND_BAN_USER";
